import api from './api';

export const getSalaryPaymentData = async (monthYear) => {
  try {
    const response = await api.get(`/salary-slips/payment-data/${monthYear}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const markSalarySlipsAsPaid = async (mobileNumbers, monthYear) => {
  try {
    const response = await api.post('/salary-slips/mark-paid', {
      mobileNumbers,
      monthYear,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addPartialPayment = async (mobileNumber, monthYear, amount, totalNetPayable, narration) => {
  try {
    const response = await api.post('/salary-slips/partial-payment', {
      mobileNumber,
      monthYear,
      amount,
      totalNetPayable,
      narration,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const editPartialPayment = async (mobileNumber, monthYear, paymentIndex, newAmount, newNarration) => {
  try {
    const response = await api.post('/salary-slips/partial-payment/edit', {
      mobileNumber,
      monthYear,
      paymentIndex,
      newAmount,
      newNarration,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deletePartialPayment = async (mobileNumber, monthYear, paymentIndex) => {
  try {
    const response = await api.post('/salary-slips/partial-payment/delete', {
      mobileNumber,
      monthYear,
      paymentIndex,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}; 